<template>
    <add-edit-lead></add-edit-lead>
</template>

<script>

import vSelect from "vue-select";
import AddEditLead from "@/layouts/components/leads/addedit-lead.vue";


export default {
 components : {
   AddEditLead
 },
};
</script>